const CardTextActionTypes = {
  SET_IS_VISIBLE: 'SET_IS_VISIBLE',
  SET_CARD_TITLE: 'SET_CARD_TITLE',
  SET_CARD_TEXT: 'SET_CARD_TEXT',
};
export default CardTextActionTypes;
